const UserSearchHeader =
    [
        {
          "name": "emp_no",
          "disablePadding": true,
          "label": "Emp No"
        },
        {
          "name": "first_name",
          "disablePadding": true,
          "label": "First Name"
        },
        {
          "name": "last_name",
          "disablePadding": true,
          "label": "Last Name"
        },
        {
          "name": "rt_month",
          "disablePadding": true,
          "label": "RT Month"
        },
        {
            "name": "exp_date",
            "disablePadding": true,
            "label": "RT Qual Exp Date"
        },
        {
            "name": "status",
            "disablePadding": true,
            "label": "Status"
        },
        {
            "name": "job_code",
            "disablePadding": true,
            "label": "Job Code"
        },
        {
            "name": "location",
            "options": {
              display: false,
            },
            "label": "Location"
        },
        {
            "name": "seniority_no",
            "options": {
              display: false,
            },
            "label": "Seniority No"
        }
    ];

export  {UserSearchHeader};
